import { render, staticRenderFns } from "./PollChoiceListEditor.vue?vue&type=template&id=2b9016f8&scoped=true"
import script from "./PollChoiceListEditor.vue?vue&type=script&lang=js"
export * from "./PollChoiceListEditor.vue?vue&type=script&lang=js"
import style0 from "./PollChoiceListEditor.vue?vue&type=style&index=0&id=2b9016f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9016f8",
  null
  
)

export default component.exports